import React, { useEffect } from 'react';
import './PaymentIntentModal.css';

interface PaymentIntentModalProps {
  onChoose: (choice: 'accept' | 'decline') => void;
}

const PaymentIntentModal: React.FC<PaymentIntentModalProps> = ({ onChoose }) => {
  // 阻止 ESC 关闭和背景滚动
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener('keydown', handleKeyDown, true);

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // 阻止点击背景关闭，必须点按钮
    e.stopPropagation();
  };

  return (
    <div className="payment-intent-modal-overlay" onClick={handleOverlayClick}>
      <div className="payment-intent-modal">
        <h2 className="payment-intent-title">Quick question about future upgrades</h2>
        <p className="payment-intent-body">
          If we later introduce paid features that unlock more powerful styling options,
          would you be interested in paying for them?
        </p>
        <div className="payment-intent-actions">
          <button
            className="payment-intent-button primary"
            onClick={() => onChoose('accept')}
          >
            Yes, I&apos;d consider paying
          </button>
          <button
            className="payment-intent-button secondary"
            onClick={() => onChoose('decline')}
          >
            Not for now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentIntentModal;


